import React, {Component} from 'react'
import {connect} from 'react-redux'
import ReduxLogin from "../../../store/actionreducers/auth/login";
import {withRouter} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles/index';
import {Button, Card, CardContent, Typography} from '@material-ui/core';
import classNames from 'classnames';
import {TextFieldFormsy, FuseAnimate} from '../../../@fuse';
import Formsy from 'formsy-react';
import Config from '../../../constants/app/config';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    intro: {
        color: '#ffffff'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class Login extends Component {
    state = {
        canSubmit: false
    };

    form = React.createRef();

    disableButton = () => {
        this.setState({canSubmit: false});
    };

    enableButton = () => {
        this.setState({canSubmit: true});
    };

    onSubmit = async (model) => {
        await this.props.submitLogin(model);
    };

    constructor(props) {
        super(props);

        let isDev =  Config.environment === 'dev';
        this.state = {
            input: {
                email: isDev ? "cc@demo.eucare.tw" : "",
                password: isDev ? "EUcare!0677" : ""
            },
            errorMsg: {
                email: "",
                password: ""
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.login.error && (this.props.login.error.username || this.props.login.error.password)) {
            this.form.updateInputsWithError({
                ...this.props.login.error
            });

            this.props.login.error = null;
            this.disableButton();
        }

        // 非 guest => 轉到跟目錄 or 之前要前往的葉面
        if (this.props.user.role !== 'guest') {
            const pathname = this.props.location.state && this.props.location.state.redirectUrl ? this.props.location.state.redirectUrl : '/';
            this.props.history.push({
                pathname
            });
        }
        return null;
    }

    render() {

        const {classes} = this.props;
        const {canSubmit} = this.state;

        return (
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0")}>

                <div
                    className={classNames(classes.intro, "flex flex-col flex-no-grow items-center p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left")}>

                    <FuseAnimate animation="transition.expandIn">
                        <img className="w-128 mb-32"
                             src="https://res.cloudinary.com/uecare/image/upload/v1524451999/official/appLogo_3x.png"
                             alt="logo"/>
                    </FuseAnimate>

                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <Typography variant="display2" color="inherit" className="font-light">
                            管理人員後台
                        </Typography>
                    </FuseAnimate>

                    <FuseAnimate delay={400}>
                        <Typography variant="subheading" color="inherit" className="max-w-512 mt-16">
                            健康益友管理人員後台 , 管理人員可在此管理相關資訊
                        </Typography>
                    </FuseAnimate>
                </div>

                <FuseAnimate animation={{translateX: [0, '100%']}}>

                    <Card className={classNames(classes.card, "mx-auto m-16 md:m-0")}>

                        <CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 ">

                            <Typography variant="title" className="md:w-full mb-32">登入</Typography>

                            <Formsy
                                onValidSubmit={this.onSubmit}
                                onValid={this.enableButton}
                                onInvalid={this.disableButton}
                                ref={(form) => this.form = form}
                                className="flex flex-col justify-center w-full"
                            >
                                <TextFieldFormsy
                                    className="mb-16"
                                    type="text"
                                    name="email"
                                    label="Email"
                                    onChange={() => {
                                        this.form.updateInputsWithError({email: undefined, password: undefined});
                                    }}
                                    value={this.state.input.email}
                                    validations={{
                                        minLength: 4
                                    }}
                                    validationErrors={{
                                        minLength: '至少4個字'
                                    }}
                                    required
                                />

                                <TextFieldFormsy
                                    className="mb-16"
                                    type="password"
                                    name="password"
                                    label="Password"
                                    onChange={() => {
                                        this.form.updateInputsWithError({email: undefined, password: undefined});
                                    }}
                                    value={this.state.input.password}
                                    validations={{
                                        minLength: 4
                                    }}
                                    validationErrors={{
                                        minLength: '至少4個字'
                                    }}
                                    required
                                />

                                <Button
                                    type="submit"
                                    variant="raised"
                                    color="primary"
                                    className="w-full mx-auto mt-16 normal-case"
                                    aria-label="LOG IN"
                                    disabled={!canSubmit}
                                    value="legacy"
                                >
                                    登入
                                </Button>

                            </Formsy>

                        </CardContent>
                    </Card>
                </FuseAnimate>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        submitLogin: async (model) => dispatch(ReduxLogin.ActionCreator.login(model)),
    }
};

function mapStateToProps({auth}) {
    return {
        login: auth.login,
        user: auth.user
    }
}


export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(Login)));



// WEBPACK FOOTER //
// ./src/main/content/login/Login.js